import React from "react";
import AliceCarousel, { Props } from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

type StagePadding = {
    paddingRight?: number;
};

type SliderComponentProps = Props & {
    items: React.ReactElement[];
    centerMode: string | boolean;
    magnifiedIndex?: number;
    activeSlideCSS?: string;
    stagePadding?: StagePadding;
    [x: string]: any;
};

const Slider = React.forwardRef<AliceCarousel, SliderComponentProps>(
    (
        {
            items = [],
            activeIndex = 0,
            centerMode,
            magnifiedIndex = 0,
            activeSlideCSS = "scale-75",
            stagePadding,
            ...props
        },
        ref
    ) => {
        const isSmall = (index: number) => {
            if (props?.activeIndex + magnifiedIndex >= items?.length) {
                return (
                    index !== props.activeIndex && magnifiedIndex + index >= items?.length
                );
            } else {
                return index !== props.activeIndex + magnifiedIndex;
            }
        };

        const sliderItems = centerMode
            ? items?.map((child: React.ReactElement<{ className?: string }>, index: number) => {
                if (isSmall(index)) {
                    return React.cloneElement(child, {
                        ...child.props,
                        className: [child.props?.className, activeSlideCSS]
                            .filter(Boolean)
                            .join(" "),
                    });
                }
                return React.cloneElement(child);
            })
            : items;

        // Значения по умолчанию для stagePadding
        const defaultStagePadding = { paddingLeft: 0, paddingRight: 100 };

        return (
            <AliceCarousel
                items={sliderItems}
                infinite
                ref={ref}
                paddingRight={stagePadding?.paddingRight ?? defaultStagePadding.paddingRight}
                {...props}
                touchTracking
                mouseTracking
                disableButtonsControls
            />
        );
    }
);

export { Slider };
